import { useTranslation } from 'react-i18next'

import { Counter } from './types'

const i18nKeys = {
  MAX_DOWNLOADS: 'Number of downloads' as const,
  MAX_TRAININGS: 'Number of trainings' as const,
  MAX_TRAINING_TESTS: 'Number of training tests' as const,
}

const CounterName = ({ counter }: { counter: Counter }) => {
  const { t } = useTranslation()

  return <span>{t(i18nKeys[counter.code])}</span>
}

export default CounterName
